import { z } from "zod";
import { isoDateOnlySchema } from "../common/date.js";
export const blockedRangeSchema = z.object({
    start: isoDateOnlySchema,
    end: isoDateOnlySchema,
});
